import { request } from '../axios_helper';

// Recommendation signals are best-effort analytics. They must never delay a
// feed render or turn a transient telemetry failure into a user-facing error.
const pending = new Map();

export function trackRecommendationEvent({ eventType, tripId = null, queryText = null } = {}) {
  const type = String(eventType || '').trim().toUpperCase();
  if (!type) return;
  const query = queryText == null ? null : String(queryText).trim();
  const key = `${type}:${tripId ?? ''}:${query ?? ''}`;
  if (pending.has(key)) return;
  pending.set(key, true);

  request('POST', '/recommendations/events', {
    eventType: type,
    tripId: tripId == null ? null : Number(tripId),
    queryText: query || null,
  })
    .catch(() => {})
    .finally(() => {
      // Keep a short client-side cooldown as an extra guard against React
      // StrictMode and browser back/forward restoring the same page twice.
      window.setTimeout(() => pending.delete(key), 30000);
    });
}
